const getDom = (selector, options = { tickNum: 5, tickTime: 1000 }) => {
  const { tickNum, tickTime } = options;
  let dom = document.querySelector(selector);
  let count = 0;
  if (!dom) {
    return new Promise(resolve => {
      const temp = setInterval(() => {
        if (count >= tickNum) {
          clearInterval(temp);
        }
        if (document.querySelector(selector)) {
          clearInterval(temp);
          dom = document.querySelector(selector);
        }
        count = count + 1;
        if (dom) {
          resolve(dom);
        }
      }, tickTime);
    });
  }
  return new Promise(resolve => {
    resolve(dom);
  });
};

export default getDom;



// WEBPACK FOOTER //
// ./src/util/getDom.js